<template>
  <div style="width: 100%; height: 100%; background-color: #e0e0e0;">
    <hm-grid></hm-grid>
  </div>
</template>

<script>
import HmGrid from "@/components/built-in/layout/HmGrid.vue";

export default {
  components: {
    HmGrid
  },
  data() {
    return {
    };
  },
  methods: {
  },
  mounted() {
  },
};
</script>
